import { create } from "zustand";

interface CameraAutoAddState {
  moreDataToLoadAutoAdd: boolean;
  setMoreDataToLoadAutoAdd: (value: boolean) => void;

  loadingMoreAutoAddData: boolean;
  setLoadingMoreAutoAddData: (value: boolean) => void;

  columnSpan: number;
  setColumnSpan: (value: number) => void;

  searchingCameras: boolean;
  setSearchingCameras: (value: boolean) => void;

  nvrNextString: string;
  setNvrNextString: (value: string) => void;

  page: number;
  setPage: (value: number) => void;

  rowsPerPage: number;
  setRowsPerPage: (value: number) => void;

  totalCamerasPerAPIResponse: number;
  setTotalCamerasPerAPIResponse: (value: number) => void;
}

export const useCameraAutoAddStore = create<CameraAutoAddState>((set) => ({
  moreDataToLoadAutoAdd: false,
  setMoreDataToLoadAutoAdd: (value: boolean) =>
    set({ moreDataToLoadAutoAdd: value }),

  loadingMoreAutoAddData: false,
  setLoadingMoreAutoAddData: (value: boolean) =>
    set({ loadingMoreAutoAddData: value }),

  searchingCameras: false,
  setSearchingCameras: (value: boolean) => set({ searchingCameras: value }),

  columnSpan: 3,
  setColumnSpan: (value: number) => set({ columnSpan: value }),

  nvrNextString: "",
  setNvrNextString: (value: string) => set({ nvrNextString: value }),

  page: 0,
  setPage: (value: number) => set({ page: value }),

  rowsPerPage: 10,
  setRowsPerPage: (value: number) => set({ rowsPerPage: value }),

  totalCamerasPerAPIResponse: 0,
  setTotalCamerasPerAPIResponse: (value: number) =>
    set({ totalCamerasPerAPIResponse: value }),
}));
